import { action } from "typesafe-actions";
import { OptionKey, OptionsActionTypes, VisTypes } from "./types";
import { AppDispatch } from "index";

export function selectItem(id: OptionKey, value: string | boolean | number) {
  return (dispatch: AppDispatch) => {
    //const { providerFilter, nodeFilter, folderFilter } = getState().Options;
    dispatch(action(OptionsActionTypes.SELECT, { id, value }));
  };
}
export function toggleItem(label: string) {
  return (dispatch: AppDispatch) => {
    dispatch(action(OptionsActionTypes.TOGGLE, label));
  };
}

export function setCurrentVisualization(label: VisTypes) {
  return (dispatch: AppDispatch) => {
    dispatch(action(OptionsActionTypes.SWITCH_VIS, { label }));
  };
}
export function search(label: string) {
  return (dispatch: AppDispatch) => {
    dispatch(action(OptionsActionTypes.SEARCH, { label }));
  };
}
export function navigationSidebar(label?: boolean) {
  return (dispatch: AppDispatch) => {
    dispatch(action(OptionsActionTypes.SIDEBAR, { label }));
  };
}
export function configSidebar(label?: boolean) {
  return (dispatch: AppDispatch) => {
    dispatch(action(OptionsActionTypes.CONFIG, { label }));
  };
}
export function setConfigSidebar(label?: boolean) {
  return (dispatch: AppDispatch) => {
    dispatch(action(OptionsActionTypes.CONFIG, { label }));
  };
}
